import { Button, Typography } from '@mui/material';
import classNames from 'classnames';
import useWidth from '../../../../../../../../../../components/Hooks/useWidth';
import LangEnum from '../../../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../../../translation/TranslationContext';
import { useAlterMessageTypeButtonStyles } from './alterMessageTypeButton.styles';

interface AlterMessageTypeButtonProps {
  text: LangEnum;
  onClick: () => void;
  isSelected: boolean;
}

const AlterMessageTypeButton = ({ isSelected, onClick, text }: AlterMessageTypeButtonProps) => {
  const { mobileWidth } = useWidth();

  const { translate } = useTranslation();

  const { classes } = useAlterMessageTypeButtonStyles();

  return (
    <Button
      size={mobileWidth ? 'large' : 'medium'}
      variant="contained"
      onClick={() => onClick()}
      className={classNames({ [classes.button]: true, [classes.selectedButton]: isSelected })}
    >
      <Typography variant="body2">{translate(text)}</Typography>
    </Button>
  );
};

export default AlterMessageTypeButton;
